export default {
  namespaced: true,
  state: {
    indice: 'home',
    opponent: null,
    
    refused: 0,
    players_updated: [],
    max_players: 7,
    cards_needed: false,
    play_action: 0,
    option: null,
    motion_completed: false,
    close_motion: 0,
    on_high: 0,
    helper: null,
    sub: null,
    room: null,
    opt: null,
    freeze: false,
    is_star_option: false,
    is_star_player: false,
    game_completed: 0,
    welcome_completed: 0,
    open_rule: null,
    use_navigation: false,
    use_storage: false,
    context_global: '',
    play_rules: 0,
    view_mode: true,
    update_crest: null,
    // audio: 'none',
    use_mouse: null,
    splash_completed: 'none',
    share_result: 0,
    instruction: null,
    pro: false,
    close_rule: 0,
    direct_rule: null
  },
  mutations: {

    /////////////////////////////////////////
    // GAME
    /////////////////////////////////////////

    'SET_INDICE' (state, indice) {
      state.indice = indice
    },
    'SET_ROOM' (state, room) {
      state.room = room
    },
    'SET_OPPONENT' (state, opponent) {
      state.opponent = opponent
    },
    'NO_CONTEST' (state) {
      state.refused += 1
    }, 
    'PLAYERS_UPDATED' (state, data) {
      state.players_updated = data
    },
    'MAX_PLAYERS' (state, max) {
      state.max_players = max
    },
    'CARDS_NEEDED' (state, bool) {
      state.cards_needed = bool
    },
    'PLAY_ACTION' (state, opt) {
      state.opt = opt
      state.play_action += 1
    },
    'CLOSE_MOTION' (state) {
      state.close_motion += 1
    },
    'OPTION_UPDATED' (state, value) {
      state.option = value
    },
    'MOTION_COMPLETED' (state, bool) {
      state.motion_completed = bool
    },
    'ON_HIGH' (state) {
      state.on_high += 1
    },
    'UPDATE_HELPER' (state, data) {
      state.helper = data
    },
    'SUB_UPDATED' (state, data) {
      state.sub = data
    },
    'FREEZE' (state, b) {
      state.freeze = b
    },
    'IS_STAR_OPTION' (state, b) {
      state.is_star_option = b
    },
    'IS_STAR_PLAYER' (state, b) {
      state.is_star_player = b
    },
    'WELCOME_COMPLETED' (state, b) {
      state.welcome_completed += 1
    },
    'OPEN_RULE' (state, rule) {
      state.open_rule = rule
    },
    'DIRECT_RULE' (state, rule) {
      state.direct_rule = rule
    },
    'CLOSE_RULE' (state) {
      state.close_rule +=1
    },
    'CONTEXT_GLOBAL' (state, context) {
      state.context_global = context
    },
    'PLAY_RULES' (state) {
      state.play_rules += 1
    },
    'VIEW_MODE' (state, b) {
      state.view_mode = b
    },
    'USE_NAVIGATION' (state, b) {
      state.use_navigation = b
    },
    'USE_STORAGE' (state, arg) {
      state.use_storage = arg
    },
    'UPDATE_CREST' (state, arg) {
      state.update_crest = arg
    },
    // 'SYNC_AUDIO' (state, audio) {
    //   state.audio = audio
    // },
    'USE_MOUSE' (state, motion) {
      state.use_mouse = motion
    },
    'GAME_COMPLETED' (state) {
      state.game_completed += 1
    },
    'SPLASH_COMPLETED' (state, arg) {
      state.splash_completed = arg
    },
    'ADD_INTRUCTION'(state, arg) {
        state.instruction = arg
    },
    'IS_PRO'(state, b) {
        state.pro = b
    },
    'SHARE_RESULT'(state) {
        state.share_result += 1
    },
  },
  getters: {
    indice: state => state.indice,   
    refused: state => state.refused,       
    players_updated: state => state.players_updated,    
    max_players: state => state.max_players,    
    cards_needed: state => state.cards_needed,      
    play_action: state => state.play_action,    
    option: state => state.option,    
    motion_completed: state => state.motion_completed,    
    close_motion: state => state.close_motion,  
    on_high: state => state.on_high,    
    helper: state => state.helper,    
    sub: state => state.sub,    
    room: state => state.room,      
    opt: state => state.opt,            
    freeze: state => state.freeze,       
    is_star_option: state => state.is_star_option,
    is_star_player: state => state.is_star_player,
    game_completed: state => state.game_completed,
    welcome_completed: state => state.welcome_completed,
    open_rule: state => state.open_rule,
    close_rule: state => state.close_rule,
    context_global: state => state.context_global,
    play_rules: state => state.play_rules,
    view_mode: state => state.view_mode,
    use_navigation: state => state.use_navigation,
    use_storage: state => state.use_storage,
    update_crest: state => state.update_crest,
    // audio: state => state.audio, 
    use_mouse: state => state.use_mouse, 
    opponent: state => state.opponent, 
    splash_completed: state => state.splash_completed, 
    instruction: state => state.instruction, 
    pro: state => state.pro, 
    direct_rule: state => state.direct_rule, 
    share_result: state => state.share_result, 
  }
}
